export default "__VITE_PUBLIC_ASSET__55823b87__"